module.exports = __webpack_public_path__ + "img/ak1yth-designbg.698be631.jpg";